module.exports = __webpack_public_path__ + "img/bind.72b720ad.png";